<template>
  <section
    class="PrivateEventsBlock"
    :aria-label="$t('accessibility.description.hotelPrivateEventsList')">
    <div class="Layout">
      <article class="Layout-section">
        <grid-item sm="4" md="10" offset-md="1">
          <div class="AiprivateEvents-titleContainer">
            <ai-typo class="AiPrivateEvents-title" as="h2" variant="heading-02">
              {{ title }}
            </ai-typo>
          </div>
          <div class="AiPrivateEvents-items" role="list">
            <grid-item
              v-for="(aiPrivateEvent, index) of privateEvents"
              :key="`AiPrivateEvent-item-${index}`"
              class="AiPrivateEvents-item-wrapper"
              :aria-label="aiPrivateEvent.title ?? ''"
              role="listitem">
              <ai-private-event
                class="AiPrivateEvents-item"
                :image="aiPrivateEvent.picto as AiPicture"
                :title="aiPrivateEvent.title ?? ''"
                :description="aiPrivateEvent.introduction ?? ''"
                :learn-more-url="
                  // eslint-disable-next-line vue/no-deprecated-filter
                  aiPrivateEvent.learnMoreUrl as string | undefined
                " />
            </grid-item>
          </div>
        </grid-item>
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import AiTypo from '../../atoms/AiTypo/AiTypo.vue';
import AiPrivateEvent from '../../molecules/AiEvent/AiPrivateEvent.vue';

import type { AiPicture, HotelEventFragment } from '~~/domains/graphql';

export interface AiPrivateEventsProps {
  title: string;
  privateEvents?: HotelEventFragment[];
}

withDefaults(defineProps<AiPrivateEventsProps>(), {
  privateEvents: () => [],
});
</script>
<style lang="scss">
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mixins';
@use '@/assets/styles/utilities/grid';
@use '@/assets/styles/utilities/colors';

.PrivateEventsBlock {
  padding-top: constants.$padding-07;
  @media (mq.$from-medium) {
    padding-bottom: constants.$padding-07;
  }
}

.AiPrivateEvents-title {
  margin-bottom: constants.$margin-04;
  @media (mq.$from-medium) {
    margin-bottom: constants.$margin-05;
  }
}
.AiPrivateEvents-items {
  @media (mq.$from-medium) {
    margin-bottom: 0;
    @include grid.grid($gutters: 48px);
  }
}
.AiPrivateEvents-item {
  margin-bottom: constants.$margin-07;

  @media (mq.$from-medium) {
    margin-bottom: 0;
    margin-right: constants.$margin-02;
  }
  &:last-child {
    margin-right: 0;
  }
}
.AiPrivateEvents-item-wrapper {
  @media (mq.$from-medium) {
    @include grid.cell(4, 48px);
  }
}

.AiprivateEvents-titleContainer {
  @media (mq.$from-medium) {
    margin-bottom: constants.$margin-05;
  }
}
</style>
